'use strict'
import request from '@/utils/request'
class CommentsuserService{
    static sendcommentscostumer(data){
        return request({
            url:'/commentscostumer/sendcommentscostumer',
            method:'post',
            data
        })
    }
}
export default CommentsuserService